"use client";

import { useSession } from "next-auth/react";
import { useRouter, useSearchParams } from "next/navigation";
import { useEffect } from "react";
import { toast } from "sonner";

export default function LoginRedirectHandler() {
    const session = useSession();
    const router = useRouter()
    const searchParams = useSearchParams();
    const callbackUrl = searchParams.get("callbackUrl"),
        error = searchParams.get("error")

    useEffect(() => {
        //if currently loading auth state - exit
        if (session.status == "loading")
            return;

        //msg
        if (session.status == "authenticated")
            toast.info("אתה כבר מחובר")

        //if no error / CB OR already auth
        if ((!callbackUrl && !error) || session.status == "authenticated")
            router.replace(callbackUrl || "/")

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [session.status])

    return <></>
}